import { defineComponent as _defineComponent } from 'vue'
import { translateLang } from '@/data/i18n/translateLang'
import { Icon, Tooltip } from 'ant-design-vue'
import Vue, { computed, h, ref } from 'vue'

import {
  PaibanTaskAction,
  PaibanTaskRow,
  PaibanTaskStatusEnum,
  StatusOptionItem,
  TableColumnProps,
  taskListColumns,
} from '../types'
import MPaibanTaskOperationCell from './m-paiban-task-operation-cell.vue'
import MPaibanTaskProgressCell from './m-paiban-task-progress-cell.vue'
import MPaibanTaskStatusCell from './m-paiban-task-status-cell.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-paiban-task-list',
  props: {
    taskList: { default: () => [] },
    loading: { type: Boolean, default: false },
    statusOptions: { default: () => [
      { label: '全部', value: 0 },
      {
        label: '等待中',
        value: PaibanTaskStatusEnum.PENDING,
      },
      {
        label: '排版中',
        value: PaibanTaskStatusEnum.RUNNING,
      },
      {
        label: '已完成',
        value: PaibanTaskStatusEnum.COMPLETED,
      },
      {
        label: '任务失败',
        value: PaibanTaskStatusEnum.FAILED,
      },
    ] }
  },
  emits: ["search", "action"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'search',
    payload: { orderNo: string; status: PaibanTaskStatusEnum | 0 }
  ): void
  (e: 'action', type: PaibanTaskAction, record: PaibanTaskRow): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { taskList: PaibanTaskRow[], loading: boolean, statusOptions: StatusOptionItem[] }





const innerOrderNo = ref('')

const innerStatus = ref<PaibanTaskStatusEnum | 0>(0)

const tableLoading = computed(() => ({
  spinning: props.loading,
  tip: `${Vue.prototype.$translateLang('数据加载中')}...`,
}))

const innerStatusOptions = computed(() => props.statusOptions)

function formatDash(val: unknown): string {
  if (val === null || val === undefined || val === '') return '-'
  return String(val)
}

function rowKey(record: PaibanTaskRow, index: number): string | number {
  return record.id ?? record.taskBatch ?? index
}

function handleOrderNoChange(e: Event): void {
  const value = (e.target as HTMLInputElement).value
  if (!value) {
    handleSearch()
  }
}

function handleSearch(): void {
  const searchPayload = {
    orderNo: innerOrderNo.value,
    status: innerStatus.value,
  }
  emit('search', searchPayload)
}

function emitAction(type: PaibanTaskAction, record: PaibanTaskRow): void {
  emit('action', type, record)
}

function renderColumnTitle(col: TableColumnProps) {
  const titleText = Vue.prototype.$translateLang(col.title as any)

  const tipTextMap = {
    optimizeRate: ['未计算自动裁剪余料利用率', '具体优化率以排版页为准'],
    boardCount: ['具体大板用量以排版页为准'],
    optimizedArea: ['具体优化面积以排版页为准'],
  }

  if (['optimizeRate', 'boardCount', 'optimizedArea'].includes(col.key)) {
    return h(
      'span',
      {
        class:
          'paiban-task-list__column-title paiban-task-list__optimize-rate-title',
      },
      [
        titleText,
        h(
          Tooltip,
          {
            props: {
              placement: 'top',
              title: `${tipTextMap[col.key as keyof typeof tipTextMap]
                .map((item) => Vue.prototype.$translateLang(item))
                .join(',')}`,
            },
          },
          [
            h(Icon, {
              props: { type: 'question-circle' },
              class: 'paiban-task-list__title-tip-icon',
            }),
          ]
        ),
      ]
    )
  }

  return h('span', { class: 'paiban-task-list__column-title' }, titleText)
}

function mapColumnWithTitle(col: TableColumnProps) {
  return {
    ...col,
    scopedSlots: undefined,
    title: () => renderColumnTitle(col),
  }
}

const columns = computed(() =>
  taskListColumns.map((col) => {
    const slotName = col.scopedSlots?.customRender
    const columnWithTitle = mapColumnWithTitle(col)

    if (slotName === 'taskStatus') {
      return {
        ...columnWithTitle,
        customRender: (text: string, record: PaibanTaskRow) =>
          h(MPaibanTaskStatusCell, {
            props: {
              text,
              record,
              statusOptions: innerStatusOptions.value,
            },
          }),
      }
    }
    if (slotName === 'progressCol') {
      return {
        ...columnWithTitle,
        customRender: (text: unknown, record: PaibanTaskRow) =>
          h(MPaibanTaskProgressCell, {
            props: { text, record },
          }),
      }
    }
    if (slotName === 'dashText') {
      return {
        ...columnWithTitle,
        customRender: (text: unknown) => formatDash(text),
      }
    }
    if (slotName === 'optimizeRate') {
      return {
        ...columnWithTitle,
        customRender: (text: unknown) => formatDash(text) + '%',
      }
    }
    if (slotName === 'operation') {
      return {
        ...columnWithTitle,
        customRender: (_text: unknown, record: PaibanTaskRow) =>
          h(MPaibanTaskOperationCell, {
            props: { record },
            on: {
              action: emitAction,
            },
          }),
      }
    }
    return columnWithTitle
  })
)

return { __sfc: true,emit, props, innerOrderNo, innerStatus, tableLoading, innerStatusOptions, formatDash, rowKey, handleOrderNoChange, handleSearch, emitAction, renderColumnTitle, mapColumnWithTitle, columns }
}

})